app.controller("VacationsController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "ConfirmModal", "toastr", "$stateParams", "usSpinnerService", "$state", 'Hr', 'DocumentsService',
    function ($scope, $uibModal, SysParam, StaticData, ConfirmModal, toastr, $stateParams, usSpinnerService, $state, Hr, DocumentsService) {
        $scope.view = 'vacations';
        $scope.totalItems = 0;
        $scope.vacations = [];
        $scope.filter = {
            status: 1
        };

        $scope.getVacations = function () {
            usSpinnerService.spin("root");
            $scope.view = 'vacations';
            Hr.getVacations($scope.filter).then(function (res) {
                $scope.vacations = res.data;
                $scope.totalItems = res.totalCount;
                usSpinnerService.stop("root");
            })
        };

        $scope.getVacationTypeDocs = function () {
            usSpinnerService.spin("root");
            $scope.view = 'documents';
            DocumentsService.getVacationTypeDocs().then(function (res) {
                $scope.vacations = res;
                $scope.totalItems = res.length;
                usSpinnerService.stop("root");
            })
        };

        $scope.filterVacation = function (e) {
            $scope.filter.status = e;
            if (e === 'ready') {
                $scope.getVacationTypeDocs();
            } else {
                $scope.getVacations();
            }
        };


        $scope.vacation = function (vacation, doc, action) {
            $uibModal.open({
                controller: "VacationAddController",
                templateUrl: _pb + 'employee/vacations/vacation-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            action: action,
                            doc: doc,
                            vacation: vacation || {}
                        };
                    }
                }
            }).result
                .then(function (result) {
                    toastr.success('', 'შვებულება წარმატებით დარედაქტირდა');
                    $scope.getVacations();
                }, function () {
                });
        };

        $scope.getVacations();

    }
]);
